module.exports = __webpack_public_path__ + "img/bladeren_high.2786f896.png";